// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2MfWo","colMaxWidth":"Table_colMaxWidth__2CF6X"};